export default __webpack_public_path__ + "static/media/rama.243de5dd.webp";